/* Dansk katalog for locale-invoice-payment-actions-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'inv.pay.undoPayment': 'Fortryd betaling',
  'inv.pay.undoRefund': 'Fortryd tilbagebetaling',
  'inv.pay.undoPaymentTitle': 'Fortryd registreret betaling?',
  'inv.pay.undoRefundTitle': 'Fortryd registreret tilbagebetaling?',
  'inv.pay.undoPaymentBody': 'Betalingen tilbageføres, og fakturaen åbnes igen med et tilsvarende restbeløb. Den oprindelige postering bevares i historikken.',
  'inv.pay.undoRefundBody': 'Tilbagebetalingen tilbageføres, og kundens tilgodehavende åbnes igen. Den oprindelige postering bevares i historikken.',
  'inv.toast.paymentReversed': 'Betalingen er tilbageført',
  'inv.toast.refundReversed': 'Tilbagebetalingen er tilbageført',
  'inv.err.paymentReverseFailed': 'Kunne ikke tilbageføre betalingen.',
  'inv.err.refundReverseFailed': 'Kunne ikke tilbageføre tilbagebetalingen.',
});
